import {
  COMMON_NAMESPACE,
  UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE,
} from "constants/i18n-namespaces";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate } from "@fortawesome/free-solid-svg-icons";
import refreshIcon from "assets/icons/refresh.svg";
import XButton from "assets/icons/x_button.svg";
import { Button, Modal as ForgeModal, ModalBody } from "kubra-ux-forge";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { getIsMobile } from "selectors/appState";

export interface IUnableToLoadAmountsModalProps {
  isOpen: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export const UnableToLoadAmountsModal = (
  props: IUnableToLoadAmountsModalProps,
) => {
  const { isOpen, onClose, onRetry } = props;

  const { t } = useTranslation(UNABLE_TO_LOAD_AMOUNTS_MODAL_NAMESPACE);
  const isMobile = useSelector(getIsMobile);
  const closeLabel = `${t("close-modal", { ns: COMMON_NAMESPACE })}`;

  return (
    <ForgeModal
      open={isOpen}
      sharpCorners
      widthInRem={70.4}
      fullScreen={isMobile}
      fullPage={isMobile}
      onBackdropClick={onClose}
      dataCy="unable-to-load-amounts-modal"
    >
      <ModalBody>
        <div className="unable-to-load-amounts-modal-container">
          <button
            type="button"
            className="unable-to-load-amounts-modal-close-button"
            onClick={onClose}
            aria-label={closeLabel}
            data-cy="unable-to-load-amounts-modal-close-button"
          >
            <img src={XButton} alt={closeLabel} />
          </button>
          <img
            src={refreshIcon}
            alt=""
            className="unable-to-load-amounts-modal-icon"
          />
          <div className="unable-to-load-amounts-modal-title">
            {t("title")}
          </div>
          <div className="unable-to-load-amounts-modal-description">
            {t("description")}
          </div>
          <Button
            type="button"
            variant="filled"
            className="unable-to-load-amounts-modal-retry-button"
            icon={<FontAwesomeIcon icon={faArrowsRotate} />}
            title={`${t("retry")}`}
            data-cy="unable-to-load-amounts-modal-retry-button"
            onClick={onRetry}
          >
            {t("retry")}
          </Button>
        </div>
      </ModalBody>
    </ForgeModal>
  );
};
